import React, { useContext } from 'react';
import ChannelContext from '../ChannelContext';
import { StructuredData } from './StructuredData';
function StructuredBreadcrumbData({ parents, breadcrumbText, breadcrumbs }) {
    const { selectedChannel } = useContext(ChannelContext);
    if (breadcrumbs) {
        const data = {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs
                .filter((crumb) => crumb.text)
                .map((crumb, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: crumb.text,
                item: crumb.path ? `${selectedChannel.url}${crumb.path}` : undefined
            }))
        };
        return React.createElement(StructuredData, { json: data });
    }
    else {
        // Deprecated, remove in next major
        let mappedParents = [];
        if (parents && parents.length > 0) {
            mappedParents = parents
                .filter((parent) => { var _a; return (_a = parent.object) === null || _a === void 0 ? void 0 : _a.breadcrumbText; })
                .map((parent, index) => {
                return {
                    '@type': 'ListItem',
                    position: parents.length - index,
                    name: parent.object.breadcrumbText.toString(),
                    item: `${selectedChannel.url}${parent.path}`
                };
            });
            mappedParents.reverse();
            const data = {
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: [
                    ...mappedParents,
                    {
                        '@type': 'ListItem',
                        position: parents.length + 1,
                        name: breadcrumbText.toString()
                    }
                ]
            };
            return React.createElement(StructuredData, { json: data });
        }
        else
            return null;
    }
}
export { StructuredBreadcrumbData };
//# sourceMappingURL=StructuredBreadcrumbData.js.map